import React, { useState } from 'react';
import { isEmailValid } from 'app/shared/utils/input';
import { isGeneralEmail, checkDNSStatus } from 'app/shared/utils/general';
import { useMailboxService } from 'hooks/users/mailbox';
import { SimpleInput } from 'app/shared/input';
import { Button } from 'app/shared/button';
import styles from './add-mailbox-modal.module.css';

const AddMailboxModal = ({ mailbox, onSuccess, closeModal }) => {
  const { initiateVerification, verifyMailbox } = useMailboxService();

  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [step, setStep] = useState('input');
  const [loading, setLoading] = useState(false);
  const [mailbox_data, setMailboxData] = useState(null);
  const [email_error, setEmailError] = useState('');

  const handleVerify = async () => {
    setEmailError('');
    if (!isEmailValid(email)) {
      setEmailError('Enter a valid email address.');
      return;
    }
    if (isGeneralEmail(email)) {
      setEmailError('Generic email domains (Gmail, Yahoo, etc.) are not allowed.');
      return;
    }

    setLoading(true);
    try {
      const { mailbox: result } = await initiateVerification({ data: { email } });
      if (!result) return;
      setMailboxData(result);
      setStep('code');
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setEmail('');
    setCode('');
    setStep('input');
    setMailboxData(null);
    setEmailError('');
  };

  const handleSubmitCode = async () => {
    setLoading(true);
    try {
      const success = await verifyMailbox(mailbox_data.id, { data: { code, email } });
      if (!success) return;
      onSuccess(email);
      resetForm();
      closeModal();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.wrapper}>
      {step === 'input' && (
        <>
          <SimpleInput
            label="Email address"
            input_id="new_mailbox_email"
            value={email}
            onInput={setEmail}
            placeholder="you@yourcompany.com"
            error={email_error}
            autoFocus
          />
          <div className={styles.footer}>
            <Button text="Verify" onClick={handleVerify} loading={loading} />
          </div>
        </>
      )}
      {step === 'code' && (
        <>
          {checkDNSStatus(mailbox.emails, email) && (
            <div className="alert alert-danger">
              You are verifying an email for a new domain. Please add the following SPF record to
              your domain settings before completing verification:
              <br />
              <br />
              <code>TXT @ IN "v=spf1 include:mail.go-mailer.com ~all"</code>
              <br />
              <br />
              Need help? Contact support@go-mailer.com
            </div>
          )}
          <div className="alert alert-info">Verification code sent to {email}</div>
          <SimpleInput
            label="Verification code"
            input_id="new_mailbox_code"
            value={code}
            onInput={setCode}
            autoFocus
          />
          <div className={styles.footer}>
            <Button text="Submit code" onClick={handleSubmitCode} loading={loading} />
          </div>
        </>
      )}
    </div>
  );
};

export default AddMailboxModal;
